import {
  AgencyNoticeDismissType,
  AgencyNoticeExhibition,
  AgencyNoticePublicationStatus,
  AgencyNoticeTargetScope,
  AgencyNoticeType,
  AgencyNoticeWidget,
  LanguageCode,
} from "~/apps/shared/constants/enums";

export type AgencyNotice = {
  token: string;
  targetScope: AgencyNoticeTargetScope;
  dismiss_type: AgencyNoticeDismissType;
  exhibition: AgencyNoticeExhibition;
  type: AgencyNoticeType;
  widget: AgencyNoticeWidget;
  content: AgencyNoticeContent;
  createdAt: Date;
  updatedAt: Date;
};

export type AgencyNoticeContent = {
  [LanguageCode.EN_US]: {
    body: string;
    title: string | null;
  };
  [LanguageCode.PT_BR]: {
    body: string;
    title: string | null;
  };
};

export class AgencyNoticeModel {
  constructor(private readonly agencyNotice: AgencyNotice) {}

  public getCreatedAtTimestamp(): number {
    return this.agencyNotice.createdAt.getTime();
  }

  public getFormattedContent(languageCode: LanguageCode): string {
    return this.agencyNotice.content[languageCode].body;
  }

  public isDismissNotPersistent(): boolean {
    return (
      this.agencyNotice.dismiss_type === AgencyNoticeDismissType.NOT_PERSISTENT
    );
  }

  public isDismissPersistent(): boolean {
    return (
      this.agencyNotice.dismiss_type === AgencyNoticeDismissType.PERSISTENT
    );
  }

  public isDismissImpossible(): boolean {
    return (
      this.agencyNotice.dismiss_type === AgencyNoticeDismissType.IMPOSSIBLE
    );
  }

  public isDialog(): boolean {
    return this.agencyNotice.widget === AgencyNoticeWidget.DIALOG;
  }

  public isHeaderBanner(): boolean {
    return this.agencyNotice.widget === AgencyNoticeWidget.HEADER_BANNER;
  }

  public isImmediate(): boolean {
    return this.agencyNotice.exhibition === AgencyNoticeExhibition.IMMEDIATE;
  }

  public isOnAccess(): boolean {
    return this.agencyNotice.exhibition === AgencyNoticeExhibition.ON_ACCESS;
  }

  public shouldShowDismissButton(): boolean {
    return this.isDismissNotPersistent() || this.isDismissPersistent();
  }
}
